import { Box, Typography } from '@mui/material'
import React, { useMemo } from 'react'

import ListEditor from '../../../common/ListEditor'

const ProductsDetail = ({
  products,
  updateProducts,
  productTypes,
  disabled = false,
  includeDates,
  billingCycleTypes,
  currentOpportunity,
  tooltip,
}) => {
  const isOpen = currentOpportunity?.isOpen

  const recurringProductIds = productTypes
    // MAGIC-NUMBER: billingCycleTypeId 1 === 'One time'
    .filter((p) => p.billingCycleTypeId !== 1)
    .map((p) => p.id)

  const editableKeys = useMemo(() => {
    const keys = [
      {
        label: 'Product',
        key: 'productId',
        isDropdown: true,
        options: productTypes,
        filterOptions: (options, item) => {
          return options.filter((o) => o.id === item.productId || !o.isArchived)
        },
        unique: true,
        getValueOnSelect: (item) => {
          // Don't know why this isn't working

          // const resolvedProduct = productTypes.find(
          //   (p) => p.id === item.productId
          // )

          // if (!item.billingCycleTypeId && resolvedProduct)
          //   item.billingCycleTypeId = resolvedProduct.billingCycleTypeId

          return item
        },
      },
      { label: 'Quantity', key: 'quantity', type: 'number' },
      {
        label: 'Price',
        key: 'price',
        type: 'number',
        adornment: '$',
        getPlaceholder: (item) => {
          const product = productTypes.find((p) => p.id === item.productId)

          return product ? `${product?.price}` : ''
        },
      },
      {
        label: 'Billing Cycle',
        key: 'billingCycleTypeId',
        isDropdown: true,
        options: billingCycleTypes,
      },
    ]

    if (includeDates) {
      keys.push({
        required: true,
        label: 'Start Date',
        key: 'startDate',
        type: 'date',
        getLabel: (customerProduct) => {
          if (customerProduct.billingCycleTypeId !== 1) return 'Start Date'
          return 'Date'
        },
      })
      keys.push({
        label: 'End Date',
        key: 'endDate',
        type: 'date',
        getShouldHide: (customerProduct) => {
          return customerProduct.billingCycleTypeId === 1
        },
      })
    }

    return keys
  }, [includeDates, recurringProductIds, products])

  return (
    <Box
      sx={{
        my: 2,
        border: '1px solid #c1bfbf',
        borderRadius: '4px',
        backgroundColor: 'white',
        p: 2,
      }}
    >
      <Typography
        variant={'h6'}
        sx={{ mb: 1, display: 'flex', alignItems: 'center' }}
      >
        Products & Services
        {tooltip && tooltip}
      </Typography>

      {isOpen && products.length === 0 && (
        <Typography color='error' sx={{ fontSize: '14px' }}>
          <i>
            You must add at least one product or service to save this
            opportunity
          </i>
        </Typography>
      )}

      <ListEditor
        disabled={disabled}
        list={products}
        editableKeys={editableKeys}
        onChange={updateProducts}
        getEmptyItem={() => ({
          productId: '',
          quantity: 1,
          price: null,
        })}
        maxLength={productTypes.length}
        getCanEdit={() => !disabled}
      />
    </Box>
  )
}

export default ProductsDetail
